import { Component, OnInit, ViewChild } from '@angular/core';
import { CashDeskCloseControlSearchItem } from '../../../../model/cash-desk-close-control/cash-desk-close-control-search-item';
import { IFilterResponse, SearchFilter } from '../../../../infrastructure/ifilter-component';
import { SelectionModel } from '@angular/cdk/collections';
import { PagerControlComponent } from 'src/app/components/controls/pager/pager-control.component';
import { SearchFilterComponent } from 'src/app/components/search-filter/search-filter.component';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { CashDeskCloseControlService } from '../../../../services/cash-desk-close-control/cash-desk-close-control.service';
import { CashDeskCloseState } from '../../../../enums/cash-desk-close-state.enum';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { MenuService } from '../../../../services/menu.service';
import { ObservationDialogComponent, ObservationDialogEditResponse } from '../../../dialogs/observation-dialog/observation-dialog.component';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { CashDeskCloseControlPaymentTotalized } from './cash-desk-close-control-payment-totalized';
import { CashDeskCloseControlPaymentTotal } from '../../../../model/cash-desk-close-control/cash-desk-close-control-payment-total';
import { CashDeskPaymentFilter } from '../../../../model/cash-desk-payment-filter';
import { CashDeskService } from '../../../../services/cash-desk.service';
import { CashDeskCloseControlPayment } from '../../../../model/cash-desk-close-control/cash-desk-close-control-payment';
import { ReportViewerDialogComponent } from '../../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';
import { CashDeskCloseExportDialogComponent } from '../cash-desk-close-export-dialog/cash-desk-close-export-dialog.component';
import { DownloadLocalFileService } from 'src/app/services/download-local-file.service';

@Component({
  selector: 'app-cash-desk-close-control-search',
  templateUrl: './cash-desk-close-control-search.component.html',
  styleUrls: ['./cash-desk-close-control-search.component.css']
})
export class CashDeskCloseControlSearchComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  searchFilters: SearchFilter[];
  dataSource = new MatTableDataSource<CashDeskCloseControlSearchItem>([]);
  selection = new SelectionModel<CashDeskCloseControlSearchItem>(true, []);
  cashDeskPaymentFilter: CashDeskPaymentFilter[] = [];

  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
   displayedColumns: string[] = ['select', 'closeNumber', 'paymentDate',
                                 'protocol', 'invoiceNumber', 'amount',
                                 'cashDeskCloseStateName', 'serviceName',
                                 'businessName', 'observation', 'star'];

  constructor( private cashDeskCloseControlService: CashDeskCloseControlService,
               private notificationToastService: NotificationToastService,
               private dialog: MatDialog,
               private cashDeskService: CashDeskService,
               private downloadLocalFileService: DownloadLocalFileService,
               private confirmDialogService: ConfirmDialogService,
               private menuService: MenuService) {
                this.menuService.setMenuTitle( 'Caja', 'Control cierre' );
  }

  get totalized(): CashDeskCloseControlPaymentTotal[] {
    if ( this.cashDeskPaymentFilter ) {
      const cashDeskCloseControlPaymentTotalized = new CashDeskCloseControlPaymentTotalized(this.cashDeskPaymentFilter, this.selection.selected );
      return cashDeskCloseControlPaymentTotalized.getCashDeskCloseControlPaymentTotals();
    } else {
      return [];
    }
  }

  ngOnInit() {
    this.cashDeskService.getCashDeskPaymentFilters().then((info) => {
      this.cashDeskPaymentFilter = info;
    });
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.pager.getAllItems().forEach(row => this.selection.select(row));
  }

  checkItemChange() {

  }

  onStartSearch(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource<CashDeskCloseControlSearchItem>(pagedItems);
  }

  onEndSearch(response: IFilterResponse<CashDeskCloseControlSearchItem>): void {
    this.searchFilters = response.searchFilters;
    this.selection = new SelectionModel<CashDeskCloseControlSearchItem>(true, []);
    this.pager.setItems(response.items);
  }

  async viewReport() {
    if ( this.selection.selected.length > 0 ) {
      try {
        this.loadingAction = true;
        if ( this.selection.selected.length > 0 ) {
          const cashDeskCloseControlPayments: CashDeskCloseControlPayment[] = [];

          this.selection.selected.forEach((item) => {
              item.CashDeskCloseControlPayments.forEach((payment) => {
                  cashDeskCloseControlPayments.push(payment);
              });
          });

          const to = this.searchFilters.find(s => s.key === 'to').value;
          const from = this.searchFilters.find(s => s.key === 'from').value;
          const reportViewer = await this.cashDeskCloseControlService
            .cashDeskCloseControlReport(from, to, cashDeskCloseControlPayments);

            this.dialog.open(ReportViewerDialogComponent, {
            width: '90%',
            height: '600px',
            data: reportViewer
           });
         }
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Control cierre caja');
      } finally {
        this.loadingAction = false;
      }
    }
  }

  async rollBack() {
    if ( this.selection.selected.length > 0 ) {
      try {
        this.loadingAction = true;
        if ( this.selection.selected.length > 0 ) {
          const hasExport = this.selection.selected.findIndex(s => s.IsExport) > -1;
          if ( !hasExport ) {
            await this.setRollBack();
          } else {
            this.confirmDialogService.confirm('Control cierre caja',
             'Existen comprobantes ya enviados al sistema contable, esta seguro de revertir su estado?',
             'Sí', 'No', false).subscribe(async (response) => {
               if (response) {
                await this.setRollBack();
               }
             });
          }
        }
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Control cierre caja');
      } finally {
        this.loadingAction = false;
      }
    }
  }

  async setRollBack() {
    const invoiceCashDeskIds = this.selection.selected.filter(s => s.InvoiceCashDeskId).map(s => s.InvoiceCashDeskId);
    const invoiceCashDeskManualIds = this.selection.selected.filter(s => s.InvoiceCashDeskManualId).map(s => s.InvoiceCashDeskManualId);
    await this.cashDeskCloseControlService.cashDeskCloseControlStateRollBack(invoiceCashDeskIds, invoiceCashDeskManualIds);
    this.searchFilter.search();
  }

  async setControled() {
    if ( this.selection.selected.length > 0 ) {
      this.changeState(CashDeskCloseState.controled);
    }
  }

  async setObserved() {
    if ( this.selection.selected.length > 0 ) {

      const dialogRef = this.dialog.open(ObservationDialogComponent, {
        width: '50%',
        data: {
          text: '',
          textMenu: 'Observaciones'
        }
      });

      dialogRef.afterClosed().subscribe((response: ObservationDialogEditResponse) => {
        if (response) {
          this.changeState(CashDeskCloseState.observated, response.text);
        }
      });
    }
  }

  async changeState( cashDeskCloseStateId: number, observation: string = '') {
    try {
      this.loadingAction = true;
      if ( this.selection.selected.length > 0 ) {
        const invoiceCashDeskIds = this.selection.selected.filter(s => s.InvoiceCashDeskId).map(s => s.InvoiceCashDeskId);
        const invoiceCashDeskManualIds = this.selection.selected.filter(s => s.InvoiceCashDeskManualId).map(s => s.InvoiceCashDeskManualId);
        await this.cashDeskCloseControlService.cashDeskCloseControlStateChange(invoiceCashDeskIds, invoiceCashDeskManualIds,
          cashDeskCloseStateId, observation);
        this.searchFilter.search();
      }
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control cierre caja');
    } finally {
      this.loadingAction = false;
    }
  }

  export() {
    this.dialog.open(CashDeskCloseExportDialogComponent, {
      width: '50%',
      disableClose: true
    });
  }


  exportItem(item: CashDeskCloseControlSearchItem) {
     this.cashDeskService.getCashDeskOpenCloseReportPdf(item.CloseNumber)
      .then((report) => {
        this.downloadLocalFileService.downLoadFile(report.ReportBase64, "Caja", "pdf");
      }).catch(err => this.notificationToastService.error(JSON.stringify(err.error), 'Caja'));
  }

}
